<template>
    <v-autocomplete
        v-model="getSetValue"
        item-value="id"
        :no-data-text="$attrs['no-data-text'] || 'No results'"
        :hint="$attrs.hint || 'Enter at least 3 characters'"
        :items="results"
        :loading="loading"
        :search-input.sync="query"
        :item-text="getItemText"
        :label="$attrs.label"
        :multiple="$attrs.multiple"
        :chips="$attrs.chips"
        :dense="$attrs.dense"
        :deletable-chips="$attrs['deletable-chips']"
        :disabled="$attrs.disabled"
        :rules="$attrs.rules"
        :hide-details="$attrs['hide-details'] === '' || $attrs['hide-details'] || false"
        :clearable="$attrs.clearable"
        :return-object="$attrs['return-object']"
        :open-on-clear="$attrs['open-on-clear']"
        :filled="$attrs.filled"
        no-filter
        @update:search-input="search"
    >
        <template slot="item" slot-scope="data">
            <div :class="{ blocked: !data.item.iam_exist }">
                {{ data.item.meno_priezvisko }}
                <span v-if="!data.item.iam_exist" class="icon">block</span>
            </div>
        </template>
    </v-autocomplete>
</template>

<script>
import { ApiConnectorInstance } from '@/Singletons';

import { clone } from '@/utils';

export default {
    props: {
        value: {},
        endpoint: {
            type: String,
            required: true,
        },
        queryParam: {
            type: String,
            default: 'search',
        },
        limit: {
            type: Number,
            default: 10,
        },
    },

    data: () => ({
        debounceId: null,
        results: [],
        loading: false,
        query: null,
    }),

    created() {
        this.results = this.getValueArray();
    },

    methods: {
        getValueArray() {
            return this.getSetValue
                ? Array.isArray(this.getSetValue)
                    ? clone(this.getSetValue)
                    : [clone(this.getSetValue)]
                : [];
        },

        search(search) {
            if (this.loading || !search || search.length < 3) {
                return;
            }

            clearTimeout(this.debounceId);

            this.debounceId = setTimeout(async () => {
                this.loading = true;

                try {
                    const response = await ApiConnectorInstance.getHttpClient('local').get(this.endpoint, {
                        params: {
                            [this.queryParam]: search,
                            page: 1,
                            limit: this.limit,
                        },
                    });

                    // na co tu je tato blbost? vytiahnem si ids a dole excludnem tie zaznamy ktore obsahuju toto id...

                    const ids = this.results.map((item) => item.id);

                    this.results = [
                        ...this.getValueArray(),
                        ...response.data.records,
                        //                        ...response.data.records.filter((item) => !ids.includes(item.id)),
                    ];
                } catch (error) {
                    throw error;
                } finally {
                    this.loading = false;
                }
            }, 500);
        },
    },

    computed: {
        getItemText() {
            return (item) => item[this.$attrs['item-text']];
        },

        getSetValue: {
            get() {
                if (Object.keys(this.$attrs).includes('single-item-array')) {
                    return (this.value && this.value[0]) || null;
                }
                return this.value;
            },

            set(value) {
                if (Object.keys(this.$attrs).includes('single-item-array')) {
                    return this.$emit('input', value ? [value] : []);
                }
                this.$emit('input', value);
                this.$emit('change', value);
            },
        },
    },
};
</script>

<style lang="less">
.v-autocomplete__content.v-menu__content .v-select-list {
    padding: 0;

    .blocked {
        display: flex;
        flex-direction: row;
        width: 100%;
        align-items: center;
        cursor: not-allowed;
        pointer-events: none;
        opacity: 0.4;

        .icon {
            margin-left: auto;
            font-size: 14px;
        }
    }
}
</style>
